"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoosters = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const getBoosters = params => (0, _request.default)({
  url: '/boosters',
  method: 'get',
  params
});
exports.getBoosters = getBoosters;